import './TableDownloadLink.scss'
import {getCompanyFileDownloadLinkAPI} from "../../Services/api";
import {useContext} from "react";
import {I18nReactContext} from "../../contexts/I18nContext";

/**
 * Component that provides a download link for table files
 * @param {object} params - The component parameters
 * @param {string} params.fileId - The file ID to download
 * @param {string} params.text - Optional custom text for the download link
 * @param {boolean} params.isReady - Whether the file is ready for download
 * @returns {JSX.Element} The download link component
 */
export const TableDownloadLink = ({fileId, text, isReady = true}) => {
    const {i18n} = useContext(I18nReactContext);
    
    const getDownloadLinkFromServer = async () => {
        if (!isReady) {
            return; // Do nothing if file is not ready
        }
        const downloadLink = await getCompanyFileDownloadLinkAPI({fileId})
        window.open(downloadLink, '_blank')
    }
    
    return <div 
        className={`TableDownloadLink ${!isReady ? 'TableDownloadLink--disabled' : ''}`} 
        onClick={getDownloadLinkFromServer}
        style={{
            cursor: isReady ? 'pointer' : 'not-allowed',
            opacity: isReady ? 1 : 0.5
        }}
    >
        {text || i18n.translate('FilesManagementPage.fileManagementTable.download')}
    </div>
}